import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class BootstrapAppRoute extends Route {
  @service('state-manager-hybrids/heartbeat-state-manager-hybrid')
  heartbeatHybrid;

  activate() {
    super.activate(...arguments);
    this.heartbeatHybrid.start();
  }

  deactivate() {
    super.deactivate(...arguments);
    this.heartbeatHybrid.stop();
  }
}

export default BootstrapAppRoute;
